var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 633",
    transform: "translate(1488.5 -3089.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#73a6b7",
    "data-name": "Ellipse 10",
    transform: "translate(-1488.5 3089.5)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1477.764 3127.237h-.066a.74.74 0 0 1-.694-.794c.43-6.316 6.382-11.243 13.525-11.243s13.1 4.927 13.525 11.21a.746.746 0 0 1-1.488.1c-.4-5.522-5.688-9.821-12.037-9.821-6.382 0-11.673 4.332-12.037 9.854a.75.75 0 0 1-.728.694",
    "data-name": "Path 206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1464.999 3113.679a7.54 7.54 0 1 1 7.54-7.54 7.536 7.536 0 0 1-7.54 7.54m0-13.558a6.018 6.018 0 1 0 6.018 6.018 6.04 6.04 0 0 0-6.018-6.018",
    "data-name": "Path 207"
  })))));
};
export default SvgProfile;